import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Button from '../components/common/Button';
import { ArrowLeft, Shield } from 'lucide-react';
import { motion } from 'framer-motion';

const PrivacyPage: React.FC = () => {
  const { labels } = useLanguage();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-100 to-primary-200 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <motion.div
        className="sm:mx-auto sm:w-full sm:max-w-4xl"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex justify-center">
          <div className="bg-primary-900 p-4 rounded-xl">
            <Shield className="h-16 w-16 text-white" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-primary-900">
          {labels.privacyPolicy}
        </h2>
        <p className="mt-2 text-center text-sm text-primary-700 font-medium">
          {labels.privacyPolicySubtitle}
        </p>
      </motion.div>

      <motion.div 
        className="mt-8 sm:mx-auto sm:w-full sm:max-w-4xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="bg-white py-8 px-4 shadow-xl sm:rounded-xl sm:px-10 border-2 border-primary-200">
          <div className="prose prose-primary max-w-none">
            <div className="mb-6">
              <Button
                type="button"
                variant="secondary"
                onClick={handleBack}
                leftIcon={<ArrowLeft size={18} />}
              >
                {labels.back}
              </Button>
            </div>
            
            <div className="space-y-6 text-primary-700">
              <div>
                <h3 className="text-xl font-semibold text-primary-900 mb-3">
                  {labels.privacyPolicyTitle}
                </h3>
                <p className="text-sm leading-relaxed">
                  {labels.privacyPolicyContent}
                </p>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold text-primary-900 mb-2">
                  {labels.dataCollectionTitle}
                </h4>
                <p className="text-sm leading-relaxed">
                  {labels.dataCollectionContent}
                </p>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold text-primary-900 mb-2">
                  {labels.dataUsageTitle}
                </h4>
                <p className="text-sm leading-relaxed">
                  {labels.dataUsageContent}
                </p>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold text-primary-900 mb-2">
                  {labels.dataProtectionTitle}
                </h4>
                <p className="text-sm leading-relaxed">
                  {labels.dataProtectionContent}
                </p>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold text-primary-900 mb-2">
                  {labels.contactInfoTitle}
                </h4>
                <p className="text-sm leading-relaxed">
                  {labels.contactInfoContent}
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyPage; 